// extracted by mini-css-extract-plugin
export default {"main_loader":"LoadingBox_main_loader__CBliS","floating":"LoadingBox_floating__hVBoo","blocked":"LoadingBox_blocked__ZhQf1"};